import { type CSSProperties } from 'react'
import { Icon, type IIconsVector, type ITooltipProps, Tooltip, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export type IButtonTooltipProps = {
  iconButton: IIconsVector
  onClickButton: React.MouseEventHandler<HTMLButtonElement>
  textButton: string
  title: string
  width?: CSSProperties['width']
  onClose?: ITooltipProps['onClose']
}

export const ButtonTooltip = ({
  title,
  textButton,
  iconButton,
  onClickButton,
  width,
  onClose,
}: IButtonTooltipProps) => {
  return (
    <Tooltip
      onClose={onClose}
      placement='top'
      padding={4}
      label={
        <div className={styles.wrap} style={{ width }}>
          <Typography
            tag={'div'}
            ariaLabel='ButtonTooltipTitle'
            variant={'body-sm-regular'}
            color={'var(--content-primary-tertiary-inverted)'}
            className={styles.title}
          >
            {title}
          </Typography>
          <button className={styles.button} onClick={onClickButton}>
            <Icon
              icon={iconButton}
              fontSize={12}
              color={'var(--content-primary-primary-inverted)'}
            />
            <Typography
              tag={'div'}
              ariaLabel='callPopUpNumber'
              variant={'body-md-regular'}
              color={'var(--content-primary-primary-inverted)'}
            >
              {textButton}
            </Typography>
          </button>
        </div>
      }
    >
      <Icon icon='infoCircle' fontSize={16} color={'var(--content-neutral-primary)'} />
    </Tooltip>
  )
}
